import { SvgProps } from "../../types";

const Failure = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}>
    <path
      fill="#4C5269"
      d="M10.398 13.283c.283 0 .52-.096.712-.287a.968.968 0 0 0 .288-.713.968.968 0 0 0-.288-.713.968.968 0 0 0-.712-.287.967.967 0 0 0-.713.287.967.967 0 0 0-.288.713c0 .283.096.52.288.713.192.191.43.287.713.287Zm-1-4h2v-6h-2v6Zm-9 11v-18c0-.55.195-1.02.587-1.413A1.926 1.926 0 0 1 2.397.283h16c.55 0 1.021.196 1.413.587.392.392.588.863.588 1.413v12c0 .55-.196 1.02-.588 1.412a1.926 1.926 0 0 1-1.412.588h-14l-4 4Zm3.15-6h14.85v-12h-16v13.125l1.15-1.125Z"
    />
  </svg>
);
export default Failure;
